module.exports = __webpack_public_path__ + "static/media/hering.7bebaeb1.png";